import { render, staticRenderFns } from "./belumMenikah.vue?vue&type=template&id=3c33ff8c&"
import script from "./belumMenikah.vue?vue&type=script&lang=js&"
export * from "./belumMenikah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports